import { limit } from "./variables"
// *[_type == 'brands' && count(*[_type == "opportunities" && visibility == true && !(_id in path('drafts.**')) && brand._ref == ^._id]) > 0]|order(name asc)

const orderingAndLimit = `order(lower(name) asc)${limit}`
const fields = "{...}"
const excludeDrafts = `count(*[_type == "opportunities" && visibility == true && !(_id in path('drafts.**')) && brand._ref == ^._id]) > 0`

export const findBrandBySlug = () =>
  groq`*[_type == 'brands' && slug.current == $slug][0]`

export const brandsGroqFirst = () =>
  groq`*[_type == 'brands' && ${excludeDrafts}]|${orderingAndLimit}{...}`

export const brandsGroqNext = () =>
  groq`*[_type == 'brands' && ${excludeDrafts} && lower(name) > lower($lastName)]|${orderingAndLimit}{...}`

export const searchByTerm = () => {
  const filter = `_type == 'brands' && ${excludeDrafts} &&
    (
      name match $term ||
      name match $normalizedTerm
    )`

  return {
    getFirstPage: () => groq`*[${filter}]|${orderingAndLimit}${fields}`,
    getNextPage: () =>
      groq`*[${filter} && lower(name) > lower($lastName)]|${orderingAndLimit}${fields}`,
  }
}
